import { Container, CircularProgress, Box } from "@mui/material";
import ItemList from "../../components/ItemList";
import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { getBackend } from "../../api/backend";
import { fetchWithCache } from "../../utils/cacheUtils";

const WorkOrders = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [machines, setMachines] = useState({});
  const [users, setUsers] = useState({});
  const [statuses, setStatuses] = useState({});

  const fieldsConfig = [
    { 
      key: "uuid", 
      label: "Placeholder", 
      type: "text", 
      displayList: false,
      displayForm: false
    },
    {
      key: "internal_number",
      label: "Nº Interno",
      type: "text",
      navTo: "work-orders",
      newPage: true,
      displayList: true,
      displayForm: false
    },
    { 
      key: "description", 
      label: "Descripción", 
      type: "text", 
      required: true,
      displayList: true,
      displayForm: true
    },
    {
      key: "machine",
      label: "Máquina",
      type: "select",
      options: machines,
      navTo: "machines",
      required: true,
      displayList: true,
      displayForm: true
    },
    {
      key: "arrival_date",
      label: "Fecha de ingreso",
      type: "date",
      displayList: true,
      displayForm: true
    },
    { key: "pickup_date", 
      label: "Fecha de salida", 
      type: "date",
      displayList: true,
      displayForm: true
    },
    { 
      key: "status_changed_at", 
      label: "Cambio de Estado", 
      type: "date",
      displayList: true,
      displayForm: false
    },
    {
      key: "user",
      label: "Usuario",
      type: "select",
      options: users,
      required: true,
      displayList: false,
      displayForm: true
    },
    {
      key: "status",
      label: "Estado",
      type: "select",
      options: statuses,
      required: true,
      displayList: true,
      displayForm: true
    },
  ];

  const fetchFormInfo = async () => {
    setIsLoading(true);
    
    try {
      // Use fetchWithCache for all reference data
      const tempMachines = await fetchWithCache('machines', 
        () => getBackend("machines"));
      
      const tempClients = await fetchWithCache('clients', 
        () => getBackend("clients"));
      
      const tempUsers = await fetchWithCache('users', 
        () => getBackend("users"));
      
      const tempStatuses = await fetchWithCache('statuses', 
        () => getBackend("statuses"));
  
      // Process the data as before
      const tempClientsDict = tempClients.reduce((acc, item) => {
        acc[item.uuid] = item.name;
        return acc;
      }, {});
  
      setMachines(
        Object.fromEntries(
          tempMachines
            .sort((a, b) => b.internal_number - a.internal_number)
            .map((item) => [
              item.uuid,
              `${item.internal_number} - ${tempClientsDict[item.client_name]}`,
            ])
        )
      );
  
      setUsers(
        Object.fromEntries(
          tempUsers.map((item) => [
            item.uuid,
            `${item.first_name} ${item.last_name}`,
          ])
        )
      );
      
      setStatuses(
        Object.fromEntries(tempStatuses.map((item) => [item.uuid, item.status]))
      );
    } catch (error) {
      console.error("Error fetching form data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchFormInfo();
  }, []);

  return (
    <Container maxWidth={false} disableGutters>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          marginBottom: "3%",
        }}
      >
        <Typography variant="h5" noWrap component="div">
          Ordenes de trabajo
        </Typography>
      </Box>
      {!isLoading ? (
        <ItemList
          fields={fieldsConfig}
          tableName="work_orders"
          objectName={"work order"}
          hasCheckbox={false}
          canEdit={true}
          tabledescription={"Ordenes de trabajo"}
        />
      ) : (
        <CircularProgress />
      )}
    </Container>
  );
};

export default WorkOrders;
